import React from 'react';
import { gcmPhotoUrl, yelpBusinessUrl } from './helpers';
import { YelpRating } from './yelp';
import './GcmCartPhoto.scss';

const GCM_LOGO = `${process.env.PUBLIC_URL}/img/gcm/gift-card-market-logo.png`;

// Merchant photo for a GCM row in the cart, with the Yelp rating pill along the bottom
// (Yelp attribution, linking to the business's Yelp page). `business` needs id, name,
// image_url, rating and review_count.
const GcmCartPhoto = ({ business }) => {
    const src = gcmPhotoUrl(business.image_url) || GCM_LOGO;
    return (
        <div className="gcm-cart-photo">
            <img
                className={`gcm-cart-photo__img ${src === GCM_LOGO ? 'gcm-cart-photo__img--logo' : ''}`}
                src={src}
                alt={business.name}
                referrerPolicy="no-referrer"
                onError={e => { e.target.src = GCM_LOGO; e.target.className = 'gcm-cart-photo__img gcm-cart-photo__img--logo'; }}
            />
            {business.rating > 0 && (
                <YelpRating
                    className="gcm-cart-photo__rating"
                    rating={business.rating}
                    reviewCount={business.review_count}
                    href={yelpBusinessUrl(business)}
                />
            )}
        </div>
    );
};

export default GcmCartPhoto;
